export const RemoteConfigNames = {
  AddVehicle: 'REACT_APP_ADD_VEHICLE_ENABLED',
  AnnuityInterestRates: 'REACT_APP_ENABLE_ANNUITY_INTEREST_RATES',
  AutoGlassVendorFNOL: 'REACT_APP_FNOL_AUTO_GLASS_VENDOR_ENABLED',
  BillingOutageWindowStart: 'REACT_APP_BILLING_OUTAGE_START',
  BillingOutageWindowEnd: 'REACT_APP_BILLING_OUTAGE_END',
  BillingLifeOutageWindowStart: 'REACT_APP_BILLING_LIFE_OUTAGE_START',
  BillingLifeOutageWindowEnd: 'REACT_APP_BILLING_LIFE_OUTAGE_END',
  CEAPolicyInfo: 'REACT_APP_CEA_POLICY_INFO_ENABLED',
  EditAutoCoverages: 'REACT_APP_EDIT_AUTO_COVERAGES_ENABLED',
  EditDriversLicense: 'REACT_APP_EDIT_DRIVERS_LICENSE_ENABLED',
  EditHomeCoverages: 'REACT_APP_EDIT_HO_COVERAGES_ENABLED',
  EditLifeAddress: 'REACT_APP_ENABLE_EDIT_LIFE_ADDRESS',
  EstimateDriverStates: 'REACT_APP_ESTIMATE_DRIVER_STATES',
  EstimateVehicle: 'REACT_APP_ESTIMATE_VEHICLE_ENABLED',
  FNOLTextNotification: 'REACT_APP_FNOL_TEXT_NOTIFICATION_ENABLED',
  LifeABSBanner: 'REACT_APP_LIFE_ABS_BANNER',
  RemoveLender: 'REACT_APP_REMOVE_LENDER_ENABLED',
  RemoveVehicle: 'REACT_APP_REMOVE_VEHICLE_ENABLED',
  RemoveVehicleReasonLoggingAPI: 'REACT_APP_REMOVE_VEHICLE_REASON_LOGGING_API',
  AppleWallet: 'REACT_APP_APPLE_WALLET_ENABLED',
  EnableQuotingCrossSellBanner: 'REACT_APP_ENABLE_QUOTING_CROSSSELL_BANNER',
  EnableQuotingBindOnline: 'REACT_APP_QUOTING_BIND_ONLINE',
  EnableQuotingBindOnlineDwelling: 'REACT_APP_QUOTING_BIND_ONLINE_DWELLING',
  EnableEASQuotingBindOnline: 'REACT_APP_EAS_QUOTING_BIND_ONLINE',
  EnableEASQuotingBindOnlineDwelling: 'REACT_APP_EAS_QUOTING_BIND_ONLINE_DWELLING',
  EnableSmarterHomeDiscountPromo: 'REACT_APP_ENABLE_SMARTER_HOME_DISCOUNT_PROMO',
  RemoveLenderMaximumLendersAllowed: 'REACT_APP_REMOVE_LENDER_MAXIMUM_LENDERS_ALLOWED',
  TempRemoveWelcomeBannerMobileApp: 'REACT_APP_TEMP_REMOVE_WELCOME_BANNER_MOBILE_APP',
  DisableExpressID: 'REACT_APP_DISABLE_EXPRESS_ID',
  EnabledTextingNotificationPreferences: 'REACT_APP_ENABLED_NOTIFICATION_PREFERENCES',
  TempEnableAdobeTargetVECIntegration: 'REACT_APP_TEMP_ENABLE_ADOBE_TARGET_VEC_INTEGRATION',
  TempBillingChangePaymentPlan: 'REACT_APP_TEMP_BILLING_CHANGE_PAYMENT_PLAN',
  TempEnableChangePaymentPlanWithSemiAnnualDiscount:
    'REACT_APP_TEMP_ENABLE_CHANGE_PAYMENT_PLAN_WITH_SEMI_ANNUAL_DISCOUNT',
  EnableHeadingDebugging: 'REACT_APP_ENABLE_HEADING_DEBUGGING',
  AutopayDiscountStates: 'REACT_APP_AUTOPAY_DISCOUNT_STATES',
  CalendlyRolloutStates: 'REACT_APP_CALENDLY_ROLLOUT_STATES',
  CalendlyBannerStates: 'REACT_APP_CALENDLY_BANNER_STATES',
  TempEnableLifeQuoting: 'REACT_APP_TEMP_ENABLE_LIFE_QUOTING',
  EnableBoardOfDirectorsLink: 'REACT_APP_ENABLE_BOARD_OF_DIRECTORS_LINK',
  TempEnableOnboarding: 'REACT_APP_TEMP_ENABLE_ONBOARDING',
  LifeQuotingApplicationOutageStart: 'REACT_APP_LIFE_QUOTING_APPLICATION_OUTAGE_START',
  LifeQuotingApplicationOutageEnd: 'REACT_APP_LIFE_QUOTING_APPLICATION_OUTAGE_END'
};
